var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6959 0.125H4.14385C2.91634 0.125 1.92212 1.11922 1.92212 2.34673V17.8988C1.92212 19.1263 2.91634 20.1205 4.14385 20.1205H8.5873L11.9199 23.4531L15.2525 20.1205H19.6959C20.9234 20.1205 21.9177 19.1263 21.9177 17.8988V2.34673C21.9177 1.11922 20.9234 0.125 19.6959 0.125ZM13.0308 17.8988H10.809V15.6771H13.0308V17.8988ZM15.3247 9.29517L14.3305 10.3172C13.5306 11.117 13.0308 11.7891 13.0308 13.4554H10.809V12.8999C10.809 11.6724 11.3089 10.5616 12.1087 9.75618L13.4918 8.35649C13.8917 7.95658 14.1416 7.40115 14.1416 6.79018C14.1416 5.56267 13.1474 4.56845 11.9199 4.56845C10.6924 4.56845 9.69816 5.56267 9.69816 6.79018H7.47643C7.47643 4.33517 9.46488 2.34673 11.9199 2.34673C14.3749 2.34673 16.3633 4.33517 16.3633 6.79018C16.3633 7.76774 15.969 8.65087 15.3247 9.29517Z",
    fill: "#ADB5BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9955,
    height: 23.3281,
    fill: "white",
    transform: "translate(1.92212 0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.ed4119075df31b67397397769fa21dd2.svg";
export { ForwardRef as ReactComponent };